import React, { useState } from 'react'
import { FormControl, MenuItem, Typography, Select } from '@mui/material'
import Box from '@mui/material/Box'

import { DailyVideo, useDevices, useLocalSessionId, useVideoTrack } from '@daily-co/daily-react'

import { useStyles } from '../styles'


export default function VideoInputList() {
  const classes = useStyles();
  const localSessionId = useLocalSessionId()
  const localVideo = useVideoTrack(localSessionId)
  const { cameras, setCamera } = useDevices()

  const updateCamera = (e:any) => {
    setCamera(e.target.value)
  }

  return (
    <div>
      {cameras && (
        <Box sx={classes.preview}>
          {localSessionId && <DailyVideo
              type="video" 
              sessionId={localSessionId} 
              mirror
              style={{
                ...(classes.videoTrack as React.CSSProperties),
                borderRadius: '.625rem',
              }}/>}
        </Box>
      )}
      {cameras.length > 1 ? (
        <FormControl fullWidth>
          <Typography variant="subtitle2" gutterBottom>
            Video Input
          </Typography>
          <Select
            onChange={updateCamera}
            value={localVideo.track?.label || ''}
            variant="outlined"
          >
            {cameras.map(device => (
              <MenuItem value={device.device.deviceId} key={device.device.deviceId}>
                {device.device.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <>
          <Typography variant="subtitle2" gutterBottom>
            Video Input
          </Typography>
          <Typography>{localVideo?.track?.label || 'No Local Video'}</Typography>
        </>
      )}
    </div>
  )
}
